module.exports = __webpack_public_path__ + "media/shelter_materials/shelter_banner_small_2x-935d236f.png";